export enum DataFor {
  LOGO = 'Logo',
  FONT = 'Font',
  COLOR = 'Color',
  CONTENT = 'Content',
  VOICE = 'Voice',
  SOCIAL = 'Social',
}

export enum BrandbookSocials {
  FACEBOOK = 'Facebook',
  INSTAGRAM = 'Instagram',
  TWITTER = 'X',
  YELP = 'Yelp',
  GOOGLE = 'Google',
  TIKTOK = 'TikTok',
  X = 'X',
  YOUTUBE = 'YouTube',
}
